import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import { BADGE_COLORS, getBadgeStyles } from "./badgeColors";
import ImagenAmpliable from "../../../../components/comun/ImagenAmpliable";
import { RUTAS } from "../../../../config/constants";
import HostService from "../../../../services/host.service";
import DateUtils from "../../../../utils/DateUtils";

/**
 * Lista de comentarios de una incidencia
 */
const ComentariosList = ({ comentarios }) => {
  if (!comentarios || comentarios.length === 0) {
    return (
      <Typography
        sx={{
          fontSize: 13,
          color: "#6c757d",
          fontStyle: "italic",
          py: 2,
          textAlign: "center",
        }}
      >
        No hay comentarios
      </Typography>
    );
  }

  return (
    <Stack spacing={1.5}>
      {comentarios.map((comentario, index) => (
        <Box
          key={index}
          sx={{
            backgroundColor: "#f8f9fa",
            border: "1px solid #e9ecef",
            borderLeft: "3px solid #cc071e",
            borderRadius: 1,
            p: { xs: 1.5, sm: 2 },
          }}
        >
          {/* Header del comentario */}
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              gap: 1,
              mb: 1,
              flexWrap: "wrap",
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 700,
                color: "#212529",
              }}
            >
              {comentario.nombre_empleado}
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
                color: "#6c757d",
              }}
            >
              {DateUtils.formatearFechaHora(comentario.creado)}
            </Typography>
            {comentario.email_enviado_a && (
              <Chip
                size="small"
                icon={<EmailIcon />}
                label={`Enviado por email a ${comentario.email_enviado_a}`}
                sx={{
                  ...getBadgeStyles(BADGE_COLORS.BLUE, { height: 22, fontSize: 11 }),
                  maxWidth: "100%",
                  "& .MuiChip-icon": { fontSize: 14, color: BADGE_COLORS.BLUE.text },
                }}
              />
            )}
          </Box>

          {/* Texto del comentario */}
          <Typography
            sx={{
              fontSize: 13,
              color: "#495057",
              mb: comentario.imagenes?.length > 0 ? 1.5 : 0,
              whiteSpace: "pre-wrap",
            }}
          >
            {comentario.comentario}
          </Typography>

          {/* Imágenes del comentario */}
          {comentario.imagenes && comentario.imagenes.length > 0 && (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              {comentario.imagenes.map((img, i) => (
                <ImagenAmpliable
                  key={i}
                  src={`${HostService.getHost() + RUTAS.IMAGENES}/${img.ruta}`}
                  alt={`Imagen ${i + 1}`}
                />
              ))}
            </Box>
          )}
        </Box>
      ))}
    </Stack>
  );
};

export default ComentariosList;
